var _rect, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLensMaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 867,
    height: 298,
    viewBox: "0 0 867 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55996_29382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 794,
    height: 259
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 794,
    height: 259,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55996_29382)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_55996_29382",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.086 162.422C685.204 162.502 685.332 162.569 685.465 162.622C802.938 209.45 880 288.05 880 377.116C880 520.646 679.871 637 433 637C186.129 637 -14 520.646 -14 377.116C-14 288.051 63.0608 209.451 180.532 162.623C180.665 162.57 180.793 162.503 180.911 162.423C245.562 118.896 334.644 92 432.999 92C531.354 92 620.435 118.896 685.086 162.422Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.532 162.623L174.237 146.831L180.532 162.623ZM180.911 162.423L190.405 176.525L180.911 162.423ZM685.465 162.622L679.17 178.413L685.465 162.622ZM685.086 162.422L675.592 176.524L685.086 162.422ZM679.17 178.413C794.451 224.367 863 298.682 863 377.116H897C897 277.419 811.425 194.532 691.76 146.83L679.17 178.413ZM863 377.116C863 440.296 818.824 500.667 740.532 546.185C662.668 591.455 553.976 620 433 620V654C558.895 654 673.704 624.368 757.621 575.578C841.112 527.037 897 457.466 897 377.116H863ZM433 620C312.024 620 203.332 591.455 125.468 546.185C47.1761 500.667 3 440.296 3 377.116H-31C-31 457.466 24.8882 527.037 108.379 575.578C192.296 624.368 307.105 654 433 654V620ZM3 377.116C3 298.682 71.5477 224.369 186.827 178.414L174.237 146.831C54.5739 194.533 -31 277.42 -31 377.116H3ZM190.405 176.525C251.899 135.124 337.577 109 432.999 109V75C331.71 75 239.225 102.669 171.417 148.321L190.405 176.525ZM432.999 109C528.421 109 614.098 135.123 675.592 176.524L694.58 148.32C626.773 102.669 534.288 75 432.999 75V109ZM186.827 178.414C188.068 177.92 189.269 177.29 190.405 176.525L171.417 148.321C172.316 147.716 173.263 147.22 174.237 146.831L186.827 178.414ZM691.76 146.83C692.734 147.219 693.681 147.715 694.58 148.32L675.592 176.524C676.728 177.289 677.93 177.919 679.17 178.413L691.76 146.83Z",
    fill: "url(#paint0_linear_55996_29382)",
    mask: "url(#path-2-inside-1_55996_29382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.998 754L433.998 -15",
    stroke: "#787878",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.998 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.998 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7973 185.312C69.6084 186.55 70.5157 188.5 72.2322 188.5L112.553 188.5C112.847 188.5 113.137 188.435 113.403 188.31L145.635 173.171C145.875 173.058 146.088 172.902 146.266 172.705C161.602 155.791 188.069 133.852 231.5 115.743C277.581 96.5272 342.759 76.5168 433.999 76.5001C524.854 76.5167 590.129 96.4019 636.432 115.5C680.464 133.661 707.34 155.728 722.744 172.719C722.915 172.907 723.116 173.058 723.343 173.17L754.081 188.295C754.356 188.43 754.658 188.5 754.964 188.5H793.324C795.031 188.5 795.943 186.571 794.772 185.328C775.346 164.716 657.715 50.6086 434.139 50.5001C434.121 50.5 434.103 50.5 434.085 50.5C434.044 50.5 434.003 50.5 433.963 50.5C433.922 50.5 433.882 50.5 433.841 50.5C433.823 50.5 433.805 50.5 433.787 50.5001C210.271 50.6085 90.6346 164.655 70.7973 185.312Z",
    fill: "#00486A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.856 754.479C423.121 754.558 423.399 754.408 423.479 754.144L424.773 749.834C424.852 749.569 424.702 749.291 424.438 749.211C424.173 749.132 423.895 749.282 423.815 749.546L422.665 753.377L418.834 752.227C418.569 752.148 418.291 752.298 418.211 752.562C418.132 752.827 418.282 753.106 418.546 753.185L422.856 754.479ZM119.56 191.237L422.56 754.237L423.44 753.763L120.44 190.763L119.56 191.237Z",
    fill: "url(#paint1_linear_55996_29382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.557 562.236C427.687 562.479 427.99 562.571 428.234 562.441L432.202 560.319C432.446 560.189 432.538 559.886 432.407 559.643C432.277 559.399 431.974 559.307 431.731 559.437L428.203 561.323L426.317 557.796C426.187 557.552 425.884 557.46 425.641 557.591C425.397 557.721 425.305 558.024 425.435 558.267L427.557 562.236ZM568.52 96.8549L427.52 561.855L428.477 562.145L569.477 97.1451L568.52 96.8549Z",
    fill: "url(#paint2_linear_55996_29382)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_55996_29382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 794,
    height: 259
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H830V259H36V0Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_55996_29382)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-2_55996_29382",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.263 162.542C802.85 209.36 880 288 880 377.116C880 520.646 679.871 637 433 637C186.129 637 -14 520.646 -14 377.116C-14 288 63.1487 209.361 180.734 162.543C245.399 118.946 334.553 92 432.999 92C531.444 92 620.598 118.945 685.263 162.542Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M685.263 162.542L675.76 176.637L677.276 177.659L678.975 178.336L685.263 162.542ZM180.734 162.543L187.022 178.337L188.721 177.661L190.237 176.638L180.734 162.543ZM678.975 178.336C794.371 224.282 863 298.637 863 377.116H897C897 277.363 811.329 194.438 691.552 146.748L678.975 178.336ZM863 377.116C863 440.296 818.824 500.667 740.532 546.185C662.668 591.455 553.976 620 433 620V654C558.895 654 673.704 624.368 757.621 575.578C841.112 527.037 897 457.466 897 377.116H863ZM433 620C312.024 620 203.332 591.455 125.468 546.185C47.1761 500.667 3 440.296 3 377.116H-31C-31 457.466 24.8882 527.037 108.379 575.578C192.296 624.368 307.105 654 433 654V620ZM3 377.116C3 298.637 71.6276 224.283 187.022 178.337L174.445 146.749C54.6698 194.439 -31 277.363 -31 377.116H3ZM190.237 176.638C251.742 135.172 337.489 109 432.999 109V75C331.618 75 239.055 102.72 171.23 148.447L190.237 176.638ZM432.999 109C528.509 109 614.255 135.171 675.76 176.637L694.767 148.446C626.942 102.719 534.38 75 432.999 75V109Z",
    fill: "url(#paint3_linear_55996_29382)",
    mask: "url(#path-13-inside-2_55996_29382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.998 754L433.998 -15",
    stroke: "#787878",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3359 192.5H110.999L145.999 173C161.293 156.047 187.816 133.958 231.499 115.743C277.581 96.5271 342.759 76.5167 433.999 76.5C524.854 76.5166 590.129 96.4019 636.432 115.5C680.707 133.761 707.636 155.972 722.999 173L757.499 192.5H795.162",
    stroke: "#07779E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.856 754.479C423.121 754.558 423.399 754.408 423.479 754.144L424.773 749.834C424.852 749.569 424.702 749.291 424.438 749.211C424.173 749.132 423.895 749.282 423.815 749.546L422.665 753.377L418.834 752.227C418.569 752.148 418.291 752.298 418.211 752.562C418.132 752.827 418.282 753.106 418.546 753.185L422.856 754.479ZM119.56 191.237L422.56 754.237L423.44 753.763L120.44 190.763L119.56 191.237Z",
    fill: "url(#paint4_linear_55996_29382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.557 562.236C427.687 562.479 427.99 562.571 428.234 562.441L432.202 560.319C432.446 560.189 432.538 559.886 432.407 559.643C432.277 559.399 431.974 559.307 431.731 559.437L428.203 561.323L426.317 557.796C426.187 557.552 425.884 557.46 425.641 557.591C425.397 557.721 425.305 558.024 425.435 558.267L427.557 562.236ZM568.52 96.8549L427.52 561.855L428.477 562.145L569.477 97.1451L568.52 96.8549Z",
    fill: "url(#paint5_linear_55996_29382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.998 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.998 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55996_29382",
    x1: 433,
    y1: 92,
    x2: 433,
    y2: 318.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55996_29382",
    x1: 179,
    y1: 300.5,
    x2: 91.5,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55996_29382",
    x1: 574.998,
    y1: 97,
    x2: 503.998,
    y2: 297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17617,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55996_29382",
    x1: 433,
    y1: 92,
    x2: 433,
    y2: 318.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55996_29382",
    x1: 179,
    y1: 300.5,
    x2: 91.5,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_55996_29382",
    x1: 574.998,
    y1: 97,
    x2: 503.998,
    y2: 297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17617,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLensMaskIcon);
export default __webpack_public_path__ + "static/media/MiniLensMaskIcon.dadfebb8a69f409bcaefa4dd4b25d9d5.svg";
export { ForwardRef as ReactComponent };